import { Button, Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { LeftOutlined, RightOutlined } from "@/icons"

import type { TokenPaginationProps } from "./TokenPagination.types"

// Previous and next for an API that pages with tokens and counts no total
export const TokenPagination = (props: TokenPaginationProps) => {
  const { page, range, hasPrevious, hasNext, previous, next } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "general.tokenPagination"
  })

  return (
    <Flex align="center" gap={8}>
      <Button
        size="small"
        icon={<LeftOutlined />}
        aria-label={t("previous")}
        disabled={!hasPrevious}
        onClick={previous}
      />
      <Text>{t("page", { page })}</Text>
      <Button
        size="small"
        icon={<RightOutlined />}
        aria-label={t("next")}
        disabled={!hasNext}
        onClick={next}
      />
      {range && <Text type="secondary">{t("range", range)}</Text>}
    </Flex>
  )
}
